import { render, staticRenderFns } from "./re_assign.vue?vue&type=template&id=fcec7070&scoped=true&"
import script from "./re_assign.vue?vue&type=script&lang=js&"
export * from "./re_assign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcec7070",
  null
  
)

export default component.exports